import * as Styles from './status-tag.styles'
import { StatusTagProps } from './status-tag.types'

export const StatusTag = ({
  status = 'complete',
  completedText = 'Concluído',
  pendingText = 'Em produção',
}: StatusTagProps) => {
  return (
    <Styles.StyledStatusTag status={status}>
      {status === 'complete' ? completedText : pendingText}
    </Styles.StyledStatusTag>
  )
}
